import axios from "axios";

export const coreAxios = axios.create({
    baseURL: process.env.REACT_APP_MAIN_URL,
});

coreAxios.interceptors.request.use(function (req) {
    if (localStorage.getItem('token')) {
        req.headers['Authorization'] = `Bearer ${localStorage.getItem('token')}`;
    }
    return req;
});
